import React from 'react'
import { useIntl } from 'react-intl'

import { getInitials } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/stringUtils'
import Avatar from '@lyrahealth-inc/ui-core/lib/atoms/avatar/Avatar'
import Label from '@lyrahealth-inc/ui-core/lib/atoms/label/Label'

import styles from './messagesDashlet.module.scss'

type ProviderPairDashletItemProps = {
  conversationId: string
  counterpartName: string
  clientFullName: string
  unreadCount: number
  onPress: () => void
}

// The dashlet's popover cannot render provider-pair threads, so the row opens the Messages Center instead.
export const ProviderPairDashletItem: React.FC<ProviderPairDashletItemProps> = ({
  conversationId,
  counterpartName,
  clientFullName,
  unreadCount,
  onPress,
}) => {
  const { formatMessage } = useIntl()
  return (
    <div
      className={styles['dashlet-item-container']}
      data-test-id={`MessagesDashlet-provider-pair-item-${conversationId}`}
    >
      <button type='button' className={styles['dashlet-item-content']} onClick={onPress}>
        <div className={styles.left}>
          <Avatar ltStyle size={35}>
            {getInitials(counterpartName)}
          </Avatar>
          <span className={styles.clientName}>
            {formatMessage(
              {
                defaultMessage: '{counterpartName} ({clientFullName}’s provider)',
                description: 'To-do unread messages row for a provider-to-provider conversation about a shared client',
              },
              { counterpartName, clientFullName },
            )}
          </span>
        </div>
        <div className={styles.right}>
          <Label
            textColor={styles.x_white}
            backgroundColor={styles.x_alert}
            borderRadius='6px'
            padding='0 7px'
            text={unreadCount}
          />
        </div>
      </button>
    </div>
  )
}
